import { render, staticRenderFns } from "./Grade10ExamResult.vue?vue&type=template&id=afaf0f3a&scoped=true&"
import script from "./Grade10ExamResult.vue?vue&type=script&lang=js&"
export * from "./Grade10ExamResult.vue?vue&type=script&lang=js&"
import style0 from "./Grade10ExamResult.vue?vue&type=style&index=0&id=afaf0f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaf0f3a",
  null
  
)

export default component.exports